import { pdf } from "@react-pdf/renderer";
import PdfReport from "./PdfReport";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import DownloadIcon from "@mui/icons-material/Download";
import moment from "moment";
import { EncryptStorage } from "encrypt-storage";
import { useState } from "react";
import { fetchApi } from "Config/fetchApi";
import { handleError } from "Helper";
import { useParams } from "react-router-dom";

const PdfDownloadButton = ({ targets, detailData, params }) => {
  const { id } = useParams();
  const encryptStorage = new EncryptStorage(process.env.REACT_APP_SECRET_KEY);
  const userInfo = encryptStorage.getItem("___info");
  const yuridiksi_user_code = userInfo?.jurisdiction_level_code || "";
  const organisasi_user_id = userInfo?.organization_id || "";

  const [isLoading, setIsLoading] = useState(false);
  const [dataDetail, setDataDetail] = useState({});

  let name = detailData?.is_ip_camera ? "Realtime" : "Playback";

  const getDataDetails = async () => {
    try {
      setIsLoading(true);

      const paramCari = `keywords=`;
      const paramPage = `page=0`;
      const paramSize = `size=1000`;
      const paramisDpo = `isDpo=${params?.valueIsDpo}`;
      const paramstartDate = `startDate=${params?.valueStartDate}`;
      const paramendDate = `endDate=${params?.valueEndDate}`;
      const organizationParam = `organizationId=${
        yuridiksi_user_code === "N" ? "" : organisasi_user_id
      }`;

      let route = `/report-detected-target/get-report-detected?reportUuid=${id}&${paramisDpo}&${paramCari}&${paramPage}&${paramSize}`;
      if (params?.valueStartDate && params?.valueEndDate) {
        route += `&${paramstartDate}&${paramendDate}`;
      }

      const response = await fetchApi().get(route);
      const newDataDetail = response?.data || {};
      setDataDetail(newDataDetail);

      const blob = await pdf(
        <PdfReport
          targets={targets}
          detailData={detailData}
          params={params}
          dataDetail={newDataDetail}
        />
      ).toBlob();

      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `Target-Report_${name}_${moment().format("DDMMYYYY")}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(url);

      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      handleError(err);
    }
  };

  return (
    <LoadingButton
      onClick={getDataDetails}
      endIcon={<DownloadIcon />}
      loading={isLoading}
      loadingPosition="end"
      variant="contained"
      className="whitespace-nowrap gap-4"
    >
      Download
    </LoadingButton>
  );
};

export default PdfDownloadButton;
